import { Button } from "@/components/button";
import IconPlayFilled from "~icons/tabler/player-play-filled";
import IconPauseFilled from "~icons/tabler/player-pause-filled";

import { TimelinePlaybackState } from "@/contexts/playback-context/types";

export const TimelinePlayButton = ({
  timelineState,
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement> & {
  timelineState: TimelinePlaybackState;
}) => {
  const getIcon = () => {
    switch (timelineState) {
      case "paused":
      case "idle":
        return <IconPlayFilled />;
      default:
        return <IconPauseFilled />;
    }
  };

  const onKeyDown = (e: React.KeyboardEvent) => {
    if (e.keyCode === 32) {
      e.preventDefault();
    }
  };

  return (
    <Button {...props} onKeyDown={onKeyDown}>
      {getIcon()}
    </Button>
  );
};
